// Sync/attachment debug logging. Off by default so the console stays quiet.
// Turn it on from the browser console (persists across reloads):
//   localStorage.setItem('safe-wallet-debug', '1')
// Turn it off:
//   localStorage.removeItem('safe-wallet-debug')
// It can also be forced on for a build with VITE_SYNC_DEBUG=true.
function debugEnabled(): boolean {
  try {
    if (import.meta.env.VITE_SYNC_DEBUG === 'true') return true;
    return typeof localStorage !== 'undefined' && localStorage.getItem('safe-wallet-debug') === '1';
  } catch {
    return false;
  }
}

export const syncLog = {
  info: (...args: unknown[]) => { if (debugEnabled()) console.info('[safe-wallet sync]', ...args); },
  warn: (...args: unknown[]) => { if (debugEnabled()) console.warn('[safe-wallet sync]', ...args); },
  error: (...args: unknown[]) => { if (debugEnabled()) console.error('[safe-wallet sync]', ...args); },
};
